import Data from '../data/home.json';
import React, { useEffect, useState } from 'react';
import { News } from './News';
import { Slider } from './Slider';
import { convertMarkdownToHTML } from "../libs/Sanitizer";
import { langData } from "../libs/Utils";

export const Home = (props) => {
    const { lang, ua } = props;
    const [sliderWidth, setSliderWidth] = useState(0);
    const [lastName, setLastName] = useState("");
    const [lastType, setLastType] = useState("in");
    const nowData = langData(lang, Data);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        setLoaded(true);
        if (ua === "pc") {
            setSliderWidth(document.getElementById("header").clientWidth - document.getElementById("me").clientWidth);
        } else {
            setSliderWidth(document.getElementById("header").clientWidth);
        }
    }, [ua]);
    const updateLast = (name, type) => {
        setLastName(name);
        setLastType(type);
    }

    const contentClass = (ua === "pc" ? "content content-offset" : "content");

    return (
        <div className={"page-wrapper " + (loaded ? "opacity-one" : "opacity-zero")} >
            <div id="top" className={ua === "pc" ? "top-pc" : "top-sp"}>
                <div id="me">
                    <div className={"image_circle" + (ua === "pc" ? "" : "_sp")}></div>
                    <div className="name_wrapper">
                        <div className="name">
                            {lang === "jp" ? <p>伴 祐樹</p> : <p>Yuki Ban, Ph.D.</p>}
                            {lang === "jp" ? <small> / Yuki Ban, Ph.D.</small> : <small></small>}
                        </div>
                    </div>
                    <div className="top_ex">
                        <div className="top_small_block">
                            <div className="top_work"></div>
                            <div>
                                {lang === "jp" ?
                                    <div><p>東京大学大学院，新領域創成科学研究科</p><p>人間環境学専攻</p><p><a href="http://www.lhei.k.u-tokyo.ac.jp/" >人間環境情報学分野</a></p></div> :
                                    <div><p><a href="http://www.lhei.k.u-tokyo.ac.jp/" >Human & Environment Informatics Lab.</a></p><p>Department of Human and Engineered Env. Studies,</p><p>Graduate School of Frontier Sciences,</p><p>The University of Tokyo</p></div>}
                            </div>
                        </div>
                        <div className="top_small_block">
                            <div className="top_job"></div>
                            <div><p>{lang === "jp" ? "特任准教授" : "Project Associate Professor"}</p></div>
                        </div>
                        <div className="top_small_block">
                            <div className="top_email"></div>
                            <div><p>{"ban [at] edu.k.u-tokyo.ac.jp"}</p></div>
                        </div>
                    </div>
                </div>

                <div>
                    <div className="top_content">
                        <div className="title">{nowData.shortbio.title}</div>
                        <div className={contentClass} dangerouslySetInnerHTML={convertMarkdownToHTML(nowData.shortbio.content)} />
                    </div>
                    <div className="top_content">
                        <div className="title">{nowData.researchinterests.title}</div>
                        <div className={contentClass} dangerouslySetInnerHTML={convertMarkdownToHTML(nowData.researchinterests.content)} />
                    </div>
                    <div className="top_content" style={{ maxWidth: sliderWidth }}>
                        <div className="title">LAST WORKS
                            <div className={"last-title " + (lastType === "in" ? "" : "gaibu")}>{lastName}</div>
                        </div>
                        <div className={contentClass}>
                            <Slider data={nowData.last} updateLast={updateLast} lang={lang} ua={ua} />
                        </div>
                    </div>
                </div>
            </div>
            <News lang={lang} />
        </div >
    );
};